import { Employee } from "../../types";

/*
 Se sul codice fiscale di un dipendente c'e' qualcosa da correggere. E' la regola dietro la barra
 rossa della riga in anagrafica e dietro il messaggio nella scheda: vive qui, e non in due
 componenti, perche' i due posti devono dire la stessa cosa dello stesso dipendente.

 A stabilire se un codice fiscale sta in piedi e' il backend (`Employee.codiceFiscaleValido`, che
 lo ricalcola a ogni lettura): qui non si verifica niente, si legge la sua risposta. Un codice
 sbagliato non impedisce di salvare il dipendente — l'anagrafica accoglie anche codici esteri o
 irregolari — quindi questo e' un rilievo, non un errore bloccante.

 `cfAVideo` serve dove il codice si puo' modificare, cioe' nella scheda: il rilievo vale finche' a
 schermo c'e' ancora il codice su cui il backend si e' pronunciato. Se l'operatore lo sta
 riscrivendo il rilievo cade, perche' del codice nuovo qui nessuno sa niente, e accusarlo lo
 stesso sarebbe dire il falso. Dove il codice si legge e basta il parametro si omette.

 Il campo assente vuol dire "non lo so", non "sbagliato": un backend che non lo manda ancora non
 fa comparire nessun rilievo.
*/
export function codiceFiscaleDaCorreggere(
  employee: Employee | null | undefined,
  cfAVideo?: string,
): boolean {
  if (!employee || employee.codiceFiscaleValido !== false) {
    return false;
  }
  if (cfAVideo === undefined) {
    return true;
  }
  return normalizzato(cfAVideo) === normalizzato(employee.cf);
}

function normalizzato(cf: string | undefined): string {
  return (cf || "").trim().toUpperCase();
}
